export default __webpack_public_path__ + "static/media/OpenDiceTray.c2970165.mp4";